import React from 'react';

const TableContext = React.createContext({});

export const TableProvider = TableContext.Provider;

export default TableContext;
